import { Pipe, PipeTransform } from "@angular/core";
import { OutputFiles } from "../../+authenticated/+product-detail/constants/product-version-output-files.constants";

@Pipe({ name: "formattedFileType" })
export class FormattedFileTypePipe implements PipeTransform {
    transform(value: any): string {
        if (value === OutputFiles.CLOSED_CAPTIONING) {
            return "CC";
        } else if (value === "AD_DBS") {
            return "AD DBS";
        } else {
            return value;
        }
    }
}
